// TODO: Remove file in COTECH-2882
/**
 * TlbPlaceholderPlugin
 *
 * Removes the `.tlb-placeholder` CSS class from the `.top‑ads-container` as soon as the
 * **top_leaderboard** GPT slot finishes rendering. The placeholder class is injected on the
 * server side to reserve space while the ad request is ongoing; once a creative is returned it
 * must be cleared so that the container collapses as intended.
 *
 * **Where the placeholder class originates(UCP):**
 *   @see skins/FandomDesktop/src/templates/FandomDesktopLayoutService_index.php
 *   @see skins/FandomMobile/src/templates/LayoutService_index.php
 *
 * **Styling tied to the placeholder class(UCP):**
 *   @see extensions/fandom/AdEngine/styles/odyssey.desktop.scss
 *   @see extensions/fandom/AdEngine/styles/odyssey.mobile.scss
 */

import type { AdEngine } from "../../core/AdEngine";
import { AdEnginePlugin, type Hooks } from "../../core/AdEnginePlugin";
import type { GptWrapper } from "../../core/GptWrapper";
// TODO: Remove in COTECH-2882
import { tlbHasAdditionalOdysseyWrapper } from "../TopStrategyTunerPlugin/helpers/tlbHasAdditionalOdysseyWrapper";

export class TlbPlaceholderPlugin extends AdEnginePlugin {
  hooks: Hooks = {
    onAdEngineInit: (adEngine: AdEngine): void => {
      if (!tlbHasAdditionalOdysseyWrapper()) {
        this.removeTlbPlaceholderClass(adEngine.gptWrapper);
      }
    },
  };

  /**
   * Attaches a one‑time listener that removes the placeholder class when top_leaderboard slot renders.
   */
  private removeTlbPlaceholderClass(gpt: GptWrapper): void {
    const handler = (event: googletag.events.SlotRenderEndedEvent): void => {
      if (event.slot.getSlotElementId() !== "top_leaderboard") {
        return;
      }

      document
        .querySelector(".top-ads-container")
        ?.classList.remove("tlb-placeholder");

      gpt.removeEventListener("slotRenderEnded", handler);
    };

    gpt.addEventListener("slotRenderEnded", handler);
  }
}
